module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_1_7ff28056.737a5b37.woff";